import React from 'react'
import AppRoutes from '../Routes'

const PageContent = () => {
  return (
    <div className='pageContent'>
    <AppRoutes/>
    </div>
  )
}

export default PageContent